import { TestingVariant } from './AbTestingTypes';
import { establishTestingVariant } from './modules/establishTestingVariant';
import { ActiveExperiments } from './AbTestingRegistry';

declare global {
	interface Window {
		setab: (variantName: string) => void;
	}
}

class AbTestingManager {
	private currentVariant: TestingVariant | null = null;

	constructor() {
		this.currentVariant = establishTestingVariant();
		if (this.currentVariant) {
			console.log(`[AB Testing] Active variant: ${this.currentVariant.name}`);
		}

		this.exposeHelpers();
	}

	public getCurrentVariant(): TestingVariant | null {
		return this.currentVariant;
	}

	private exposeHelpers() {
		if (typeof window !== 'undefined') {
			window.setab = (variantName: string) => {
				const experiment = ActiveExperiments.find((e) =>
					e.variants.some((v) => v.variant.name === variantName)
				);

				if (!experiment) {
					console.error(`Variant "${variantName}" not found in any active experiment.`);
					const available = ActiveExperiments.flatMap((e) =>
						e.variants.map((v) => v.variant.name)
					);
					console.log('Available variants:', available);
					return;
				}

				const storageKey = `dac_ab_test_${experiment.name}`;
				try {
					localStorage.setItem(storageKey, variantName);
					console.log(
						`[AB Testing] Set experiment "${experiment.name}" to variant "${variantName}". Reloading...`
					);
					window.location.reload();
				} catch (e) {
					console.error('[AB Testing] Failed to save variant to localStorage', e);
				}
			};
		}
	}
}

export const abTestingManager = new AbTestingManager();
